import { render } from "./ChannelsActions.vue?vue&type=template&id=e2cdb2dc&scoped=true&lang=pug"
import script from "./ChannelsActions.vue?vue&type=script&lang=js"
export * from "./ChannelsActions.vue?vue&type=script&lang=js"

import "./ChannelsActions.vue?vue&type=style&index=0&id=e2cdb2dc&scoped=true&lang=sass"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2cdb2dc"]])

export default __exports__